import { i18n } from '@/plugins/i18n'
import { statusStr } from '@/constants/settlementStatus'
import {statusVariant} from "@/constants/settlementStatus";

export default [
    {
        field: 'id',
        title: i18n.t('label.settlement_id'),
        sortable: false,
        textAlign: 'center',
        width: 90,
    },
    {
        field: 'full_name',
        title: i18n.t('label.user_full_name'),
        sortable: false,
        textAlign: 'center',
        width: 90,
    },
    {
        field: 'amount',
        title: i18n.t('label.amount') + " (" + i18n.t('currency.rial') + ")",
        sortable: true,
        textAlign: 'center',
        width: 90,
    },
    {
        field: 'created_at',
        title: i18n.t('label.date_created'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        width: 80,
        textAlign: 'center',
        template: (row) => {
            let variant   = 'badge-'+statusVariant(row.status)
            let status = statusStr.get(row.status)

            return '<div class="badge '+variant+' text-white">'+ status +'</div>'
        },
        sortable: true,
    },
    {
        field: 'sheba_number',
        title: i18n.t('label.sheba_number'),
        sortable: false,
        textAlign: 'center',
    },

]
